import React from "react";
// @ts-ignore
import t from "../helpers/t";

type Tab = {
    isAccessible: boolean,
    link: string,
    isActive: boolean,
    style?: object
    icon: string,
    name: string,
    data_inb_val: string
};

type Props = {
    tab: Tab
};
const SubmenuItem = ({ tab }: Props) =>{
        return (
            <>
                { tab.isAccessible &&
                <li data-inb-val={tab.data_inb_val} title={t('toggle_${a}_view',{a:t(tab.data_inb_val)})} className={tab.isActive ? 'active' : ''} style={typeof tab.style !== 'undefined' ? tab.style : {}}>
                    <a href={tab.link}>
                        <i className={"fi " + tab.icon}> </i>
                        <span>{tab.name}</span> </a>
                </li>
                }
            </>
        );
};

export default SubmenuItem;